import React, { Component } from "react";
import { connect } from 'react-redux';
import { metadataService, ServiceUtil } from "../_services";
import PropTypes from 'prop-types';
import moment from "moment";
import { Card, CardBody, CardHeader, Row, Col, Collapse, Alert, thead, tr, th, tbody, td, Table, Dropdown, DropdownToggle, DropdownItem, DropdownMenu } from 'reactstrap';
import { BsDownload } from 'react-icons/bs';
import { DocumentApi, LoanInfoApi } from "../_services";
import { SlPageTitle, SlBusyIndicator } from "./editors";
import { AiOutlineFilePdf, AiOutlineBook, AiFillCaretRight } from "react-icons/ai";
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
import DocumentUpload from "./DocumentUpload";
import { documentActions } from "../_actions";
import { loanInfoActions } from "../_actions/loanInfo.actions";
import NotificationModal from "./subcomponents/NotificationModal";
import DocumentCustomerDetails from "./subcomponents/DocumentCustomerDetails";

class MyDocuments extends Component {
    constructor(props) {
        super(props);

        this.state = {
            documents: [],
            contracts: [],
            reducedDocuments: [],
            renderedDocuments: [],
            oldestDocumentYear: 0,
            docsByUserLoading: true,
            error: '',
            notificationModalOpen: false,
            currentYear: new Date().getFullYear(),
            dateArrow: <IoMdArrowDropdown />,
            typeArrow: <IoMdArrowDropdown />,
            nameArrow: <IoMdArrowDropdown />,
        }

    }

    componentDidMount() {
        this.setState({ docsByUserLoading: true });
        DocumentApi.getDocumentsByUser().then(res => {
            if (res.status < 1) {
                this.setState({
                    documents: res.data,
                    docsByUserLoading: false,
                })
            } else {
                this.setState({ error: "Failed to load user Documents", docsByUserLoading: false, })
            }
            this.updateTable();
        });
        LoanInfoApi.getLoanContracts().then(res => {
            if (res.status < 1) {
                this.setState({
                    contracts: res.data,
                })
            } else {
                this.setState({ error: "Failed to load user Contracts", docsByUserLoading: false, })
            }
            this.updateTable();
        });
        if (!this.props.hasActiveLeads) this.props.actions.LoadAccountViews();
    }

    viewDocument = (doc) => {

        if (doc.id === undefined) {
            //LP ESign
            return this.downloadDocument(doc)
        }

        sessionStorage.setItem("documentData", JSON.stringify(doc));
        window.open("/view-document", "_blank");

        if (!doc.isViewed) {
            this.markDocumentAsViewed(doc);
        }
    }

    downloadDocument = (doc) => {
        if (doc.id === undefined) {
            LoanInfoApi.downloadLoanContract(doc.loanId).then((response) => {
                let link = document.createElement("a");
                link.href = "data:application/pdf;base64," + response.data;
                link.download = `${doc.displayFileName}`;
                link.click();
                setTimeout(function () {
                    window.URL.revokeObjectURL(link);
                }, 200);
            });
        }
        else {
            DocumentApi.getFile(doc.id).then((response) => {
                let link = document.createElement("a");
                if (doc.documentTypeText === "PDF") {
                    link.href = "data:application/pdf;base64," + response.data;
                } else {
                    link.href = "data:image/png;base64," + response.data;
                }
                link.download = `${doc.displayFileName}`;
                link.click();
                setTimeout(function () {
                    window.URL.revokeObjectURL(link);
                }, 200);
            });

            if (!doc.isViewed) {
                this.markDocumentAsViewed(doc);
            }
        }
    }

    markDocumentAsViewed(doc) {
        let docIndex = this.state.documents.findIndex(x => x.id === doc.id);
        if (docIndex !== -1) {
            let { documents } = this.state;
            doc.isViewed = true;
            documents[docIndex].isViewed = doc.isViewed;

            this.setState({ documents: documents });

            DocumentApi.updateDocument(doc);

        }
    }

    updateTable = () => {
        try {
            const reducedDocuments = [...this.state.documents];

            this.state.contracts.map(c => {
                reducedDocuments.push({
                    loanId: c.loanId,
                    creationTime: c.paidOffDate == null ? c.dateMade : c.paidOffDate,
                    documentClassificationText: "Contract",
                    displayFileName: "loan_contract_" + c.loanId + ".pdf",
                    fileName: "loan_contract_" + c.loanId + ".pdf",
                })
            });

            const oldestDocument = reducedDocuments.reduce((prev, curr) => { return new Date(prev.creationTime).getTime() < new Date(curr.creationTime).getTime() ? curr : prev; });
            const oldestDocumentYear = new Date(oldestDocument.creationTime).getFullYear();

            this.setState({ reducedDocuments: reducedDocuments, oldestDocumentYear: oldestDocumentYear, renderedDocuments: reducedDocuments });
        } catch (error) {
        }
    }

    filterByYear(e) {
        try {
            const year = e.target.value;
            const filteredDocuments = this.state.reducedDocuments.filter((doc) => {
                if (new Date(doc.creationTime).getFullYear() === Number(year)) {
                    return doc;
                }
            })
            this.setState({ renderedDocuments: filteredDocuments })
        }
        catch (error) {
        }
    }

    orderBy(header) {
        switch (header) {
            case "date":
                const dateArrow = this.state.dateArrow.type.name === "IoMdArrowDropdown" ? <IoMdArrowDropup /> : <IoMdArrowDropdown />;
                const orderedDocumentsByDate = this.state.dateArrow.type.name === "IoMdArrowDropdown" ? this.state.renderedDocuments.sort((a, b) => a.creationTime.localeCompare(b.creationTime)) : this.state.renderedDocuments.sort((a, b) => b.creationTime.localeCompare(a.creationTime))

                this.setState({ dateArrow: dateArrow, renderedDocuments: orderedDocumentsByDate })
                break;
            case "type":
                const typeArrow = this.state.typeArrow.type.name === "IoMdArrowDropdown" ? <IoMdArrowDropup /> : <IoMdArrowDropdown />;
                const orderedDocumentsByType = this.state.typeArrow.type.name === "IoMdArrowDropdown" ? this.state.renderedDocuments.sort((a, b) => a.documentClassificationText.localeCompare(b.documentClassificationText)) : this.state.renderedDocuments.sort((a, b) => b.documentClassificationText.localeCompare(a.documentClassificationText))

                this.setState({ typeArrow: typeArrow, renderedDocuments: orderedDocumentsByType })

                break;
            case "name":
                const nameArrow = this.state.nameArrow.type.name === "IoMdArrowDropdown" ? <IoMdArrowDropup /> : <IoMdArrowDropdown />;
                const orderedDocumentsByName = this.state.nameArrow.type.name === "IoMdArrowDropdown" ? this.state.renderedDocuments.sort((a, b) => a.displayFileName.localeCompare(b.displayFileName)) : this.state.renderedDocuments.sort((a, b) => b.displayFileName.localeCompare(a.displayFileName))

                this.setState({ nameArrow: nameArrow, renderedDocuments: orderedDocumentsByName })
        }
    }

    range = (min, max) => Array.from({ length: max - min + 1 }, (_, i) => min + i);

    render() {
        const { renderedDocuments, currentYear, oldestDocumentYear, documents, dateArrow, typeArrow, nameArrow } = this.state;
        const yearsPast = oldestDocumentYear === currentYear ? [currentYear] : this.range(oldestDocumentYear, currentYear);
        return (
            <div>
                {renderedDocuments.length > 0 &&
                    <div>
                        <Row className="mb-3">
                            <Col>
                                <SlPageTitle pageName="MyDocuments" />
                            </Col>
                        </Row>
                        <Table bordered striped>
                            <thead>
                                <tr style={{ display: "flex", alignItems: "center" }}>
                                    <th style={{ border: "0" }}>View</th>
                                    <select name="years" id="years" defaultValue={this.state.currentYear} onChange={(e) => this.filterByYear(e)}>
                                        {yearsPast.map((year) => {
                                            return (
                                                <option value={year}>{year}</option>
                                            )
                                        })}
                                    </select>

                                </tr>
                            </thead>
                            <thead>
                                <tr>
                                    <th><div onClick={() => { this.orderBy("date") }}>Date{dateArrow}</div></th>
                                    <th><div onClick={() => { this.orderBy("type") }}>Type{typeArrow}</div></th>
                                    <th><div onClick={() => { this.orderBy("name") }}>Name{nameArrow}</div></th>
                                </tr>
                            </thead>
                            <tbody>
                                {renderedDocuments.map((doc, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>{new Date(Date.parse(doc.creationTime)).toLocaleDateString()}</td>
                                            <td>{doc.documentClassificationText}</td>
                                            <td style={{
                                                display: "flex",
                                                flexDirection: "row",
                                                justifyContent: "space-between"
                                            }} ><a href="javascript:;" onClick={() => { this.viewDocument(doc) }}>{doc.fileName}</a>
                                                <div
                                                    className="UploadButton"
                                                    onClick={() => this.downloadDocument(doc)}
                                                >
                                                    <BsDownload size={20} />
                                                </div>
                                            </td>
                                        </tr>
                                    )

                                })}
                            </tbody>
                        </Table>
                    </div>
                }
                {renderedDocuments.length === 0 && <h1 className="stepper-title padTop">{metadataService.getMessage("DocumentsNotFound")}</h1>}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        idDocsRejected: state.documents.idDocsRejected,
        hasActiveLeads: state.loanInfo.accountViews ? state.loanInfo.accountViews.hasActiveLeads : false
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        actions: {
            loadLeadDocumentsByUser: () => {
                dispatch(documentActions.loadLeadDocumentsByUser());
            },
            LoadAccountViews: () => {
                dispatch(loanInfoActions.loadAccountViews());
            }
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MyDocuments);
